// import React, { useState } from "react";
// import { FaSort, FaFilter } from "react-icons/fa";

// const SortAndFilter = () => {
//   const [formData, setFormData] = useState({
//     sortBy: "",
//     filter: "",
//   });


//   return (
//     <div className="flex items-center  justify-between w-full p-4 bg-gray-500 border rounded-md shadow-sm">
//       {/* Sort By Section */}
//       <div className="flex items-center gap-2">
//         <FaSort className="text-xl text-black" />
//         <label htmlFor="sort" className="text-black font-medium">
//           SORT BY 
//         </label>
//       </div>

//       {/* Filter Section */}
//       <div className="flex items-center gap-2">
//         <FaFilter className="text-xl text-black" />
//         <label htmlFor="filter" className="text-black font-medium">
//           FILTER
//         </label>

//       </div>
//     </div>
//   );
// };

// export default SortAndFilter;




// import React, { useState } from "react";
// import { FaSort, FaFilter } from "react-icons/fa";
// import { useNavigate } from "react-router-dom"; // Import useNavigate

// const SortAndFilter = () => {
//   const navigate = useNavigate(); // Initialize navigate
//   const [formData, setFormData] = useState({
//     sortBy: "",
//     filter: "",
//   });

//   const handleSortClick = () => {
//     navigate("/sort"); // Navigate to the "Sort" component
//   };

//   const handleFilterClick = () => {
//     navigate("/date"); // Navigate to the "Filter" component (optional)
//   };

//   return (
//     <div className="flex items-center justify-center gap-36 w-full p-4 bg-white  border rounded-md shadow-sm">
//       {/* Sort By Section */}
//       <div 
//         className="flex items-center gap-2 cursor-pointer" 
//         onClick={handleSortClick} // Add click handler
//       >
//         <FaSort className="text-xl text-black" />
//         <label htmlFor="sort" className="text-black font-medium">
//           SORT BY
//         </label>
//       </div>

//       {/* Filter Section */}
//       <div 
//         className="flex items-center gap-2 cursor-pointer" 
//         onClick={handleFilterClick} // Add click handler
//       >
//         <FaFilter className="text-xl text-black" />
//         <label htmlFor="filter" className="text-black font-medium">
//           FILTER
//         </label>
//       </div>
//     </div>
//   );
// };

// export default SortAndFilter;



// import React, { useState } from "react";
// import { FaSort, FaFilter } from "react-icons/fa";
// import { useNavigate } from "react-router-dom"; // Import useNavigate

// const SortAndFilter = () => {
//   const navigate = useNavigate(); // Initialize navigate
//   const [formData, setFormData] = useState({
//     sortBy: "",
//     filter: "",
//   });

//   const handleSortClick = () => {
//     navigate("/sort"); // Navigate to the "Sort" component
//   };

//   const handleFilterClick = () => {
//     navigate("/date"); // Navigate to the "Filter" component (optional)
//   };

//   return (
//     <div className="flex items-center justify-center gap-36 w-full p-4 bg-white  border rounded-md shadow-sm">
//       {/* Sort By Section */}
//       <div 
//         className="flex items-center gap-2 cursor-pointer" 
//         onClick={handleSortClick} // Add click handler
//       >
//         <FaSort className="text-xl text-black" />
//         <label htmlFor="sort" className="text-black font-medium">
//           SORT BY
//         </label>
//       </div>

//       {/* Filter Section */}
//       <div 
//         className="flex items-center gap-2 cursor-pointer" 
//         onClick={handleFilterClick} // Add click handler
//       >
//         <FaFilter className="text-xl text-black" />
//         <label htmlFor="filter" className="text-black font-medium">
//           FILTER
//         </label>
//       </div>
//     </div>
//   );
// };

// export default SortAndFilter;




// import React, { useState } from "react";
// import { FaSort, FaFilter } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";
// import SortBy from "./SortBy"; // Import the SortBy component

// const SortAndFilter = () => {
//   const navigate = useNavigate();
//   const [formData, setFormData] = useState({
//     sortBy: "",
//     filter: "",
//   });

//   const [isSortByOpen, setIsSortByOpen] = useState(false); // Manage the modal visibility

//   const handleSortClick = () => {
//     setIsSortByOpen(true); // Open the SortBy modal
//   };

//   const handleFilterClick = () => {
//     navigate("/date");
//   };

//   return (
//     <div className="flex items-center justify-center gap-36 w-full p-4 bg-white border  shadow-sm">
//       {/* Sort By Section */}
//       <div
//         className="flex items-center gap-2 cursor-pointer"
//         onClick={handleSortClick} // Open SortBy modal on click
//       >
//         <FaSort className="text-xl text-black" />
//         <label htmlFor="sort" className="text-black font-medium">
//           SORT BY
//         </label>
//       </div>

//       {/* Filter Section */}
//       <div
//         className="flex items-center gap-2 cursor-pointer"
//         onClick={handleFilterClick}
//       >
//         <FaFilter className="text-xl text-black" />
//         <label htmlFor="filter" className="text-black font-medium">
//           FILTER
//         </label>
//       </div>

//       {/* Render the SortBy modal if it's open */}
//       {isSortByOpen && <SortBy closeModal={() => setIsSortByOpen(false)} />}
//     </div>
//   );
// };

// export default SortAndFilter;




import React, { useState } from "react";
import { FaSort, FaFilter } from "react-icons/fa";
import DateTimeFilter from "./DateTimeFilter";
import SortBy from "./SortBy";

const SortAndFilter = () => {
  const [isSortByOpen, setIsSortByOpen] = useState(false);
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const handleSortClick = () => {
    setIsSortByOpen(true);
  };

  const handleFilterClick = () => {
    setIsFilterOpen(true);
  };

  const closeFilterModal = () => {
    setIsFilterOpen(false);
  };

  return (
    <div className="flex items-center justify-center gap-36 w-full p-4 bg-white border shadow-sm">
      <div
        className="flex items-center gap-2 cursor-pointer"
        onClick={handleSortClick}
      >
        <FaSort className="text-xl text-black" />
        <label htmlFor="sort" className="text-black font-medium">
          SORT BY
        </label>
      </div>
      <div
        className="flex items-center gap-2 cursor-pointer"
        onClick={handleFilterClick}
      >
        <FaFilter className="text-xl text-black" />
        <label htmlFor="filter" className="text-black font-medium">
          FILTER
        </label>
      </div>
      {isFilterOpen && (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white  rounded-lg shadow-lg w-full h-full max-w-md">
            <DateTimeFilter closeModal={closeFilterModal} />
          </div>
        </div>
      )}
      {isSortByOpen && (
        <SortBy closeModal={() => setIsSortByOpen(false)} />
      )}
    </div>
  );
};
export default SortAndFilter;
